import { v4 as uuid } from 'uuid';
import { getCookieValue } from '../get-cookie-value';

export const getDeviceId = (): string => {
  const deviceId = getCookieValue('cookie_id');

  return deviceId ?? uuid();
};

export const getDeviceIdWithoutHmac = (defaultValue = uuid()) => {
  const deviceId = getDeviceId();
  return deviceId.length > 0
    ? deviceId.slice(deviceId.length - 36)
    : defaultValue.slice(defaultValue.length - 36);
};
